import { Dot } from '../../components/PeriodTable/mocks'
import { ClassifiedLiberalBlock } from '../../rest/types/Classified'

export function BlockLiberalTransformer({
  block,
  t,
}: {
  block: ClassifiedLiberalBlock
  t: any
}) {
  console.log('block', block)
  return {
    ...((block?.speciality?.name || block?.cabinetType?.name) && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.speciality?.name
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  text: block?.speciality?.name,
                },
              ]
            : []),

          ...(block?.cabinetType?.name
            ? [
                {
                  title: t('ads_types_cabinet_type_title'),
                  text: block?.cabinetType?.name,
                },
              ]
            : []),
        ],
      },
    }),

    ...(block?.comments && {
      adsDetails: {
        withColumn: false,
        items: [
          {
            label: t('ads_details_liberal_comments'),
            value: block?.comments,
          },
        ],
      },
    }),

    adsReplacementDate: {
      title: t('ads_replacement_date_title'),
      periods: {
        label: t('ads_replacement_date_period_label'),
        months: block?.periodMonths?.map((item) =>
          t(`ads_details_liberal_period_months_${item}`)
        ),
      },
      periodTable: {
        labels: {
          morningRowLabel: t('ads_replacement_date_morning_row_Label'),
          afternoonRowLabel: t('ads_replacement_date_afternoon_row_Label'),
          mondayLabel: t('ads_replacement_date_monday_label'),
          tuesdayLabel: t('ads_replacement_date_tuesday_label'),
          wednesdayLabel: t('ads_replacement_date_wednesday_label'),
          thursdayLabel: t('ads_replacement_date_thursday_label'),
          fridayLabel: t('ads_replacement_date_friday_label'),
          saturdayLabel: t('ads_replacement_date_saturday_label'),
          sundayLabel: t('ads_replacement_date_sunday_label'),
          columnLabel: t('ads_replacement_date_column_label'),
        },
        monday: {
          ...(block?.periodDays?.mondayMorning && {
            morning: <Dot />,
          }),
          ...(block?.periodDays?.mondayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        tuesday: {
          ...(block?.periodDays?.tuesdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.periodDays?.tuesdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        wednesday: {
          ...(block?.periodDays?.wednesdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.periodDays?.wednesdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        thursday: {
          ...(block?.periodDays?.thursdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.periodDays?.thursdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        friday: {
          ...(block?.periodDays?.fridayMorning && {
            morning: <Dot />,
          }),
          ...(block?.periodDays?.fridayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        saturday: {
          ...(block?.periodDays?.saturdayMorning && {
            morning: <Dot />,
          }),
          ...(block?.periodDays?.saturdayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        sunday: {
          ...(block?.periodDays?.sundayMorning && {
            morning: <Dot />,
          }),
          ...(block?.periodDays?.sundayAfternoon && {
            afternoon: <Dot />,
          }),
        },
        withGrid: true,
      },
      frequency: {
        label: t('ads_details_liberal_frequency_title'),
        value: block?.frequencies
          ? t(`ads_details_liberal_frequency_${block?.frequencies}_years`)
          : '',
      },
    },

    adsHighlight: {
      title: t('ads_highlight_liberal_title'),
      text: t('ads_highlight_liberal_text'),
      button: {
        label: t('ads_highlight_button_label'),
        href: t('ads_intro_link_href_liberal'),
      },
    },
  }
}
